module.exports = __webpack_public_path__ + "img/noprize.c9318d49.png";